var render = function render(){var _vm=this,_c=_vm._self._c;return _c('print-template',{attrs:{"viewHeader":false,"viewFooter":false}},[_c('ul',{staticClass:"list-unstyled"},_vm._l((_vm.items),function(item,index){return _c('li',{key:index},[_c('svg',{attrs:{"id":'PART_ID_' + item.part.id}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }